import React, { useRef } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  Datagrid,
} from 'react-admin';

import { Card } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import DialogoDeleteResource from './DialogoDeletar';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
//import ActionsField from './ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import Dialogo from './ContainerDialogoProduto';
import Filter from './Filter';
import {} from '../../utils/dadosTelas';
//
const MyList = ({ ...props }) => {
  const refDialogoCompra = useRef(null);
  const refDialogoDeleteResource = useRef(null);

  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }
  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }
  function deleteHundle(record) {
    if (refDialogoDeleteResource.current)
      refDialogoDeleteResource.current.handleOpen(record);
  }

  return (
    <>
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField source="ncm" label="NCM" />
          <TextField source="cst" label="CST" />
          <TextField source="cfop" label="CFOP" />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            /* handleDelete={deleteHundle}
            handleEdit={handleEdit}
            ativo */
            actions={[
              {
                key: 'edit',
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: (record) => handleEdit(record),
              },
              {
                key: 'delete',
                title: 'Deletar',
                icon: <DeleteOutlineIcon />,
                onClick: (record) => deleteHundle(record),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} />
      <DialogoDeleteResource ref={refDialogoDeleteResource} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

function formatPorcentagem(valor) {
  return valor !== null && valor !== undefined
    ? `${valor.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}%`
    : '';
}

const PostPanel = ({ record }) => (
  <div>
    <div style={{ marginTop: '5px' }}>
      <span style={{ fontWeight: 'bold', marginRight: '10px' }}>IPI:</span>
      <span>{`${formatPorcentagem(record.ipi)}`}</span>
    </div>
    <div style={{ marginTop: '5px' }}>
      <span style={{ fontWeight: 'bold', marginRight: '10px' }}>PIS:</span>
      <span>{`${formatPorcentagem(record.pis)}`}</span>
    </div>
    <div style={{ marginTop: '5px' }}>
      <span style={{ fontWeight: 'bold', marginRight: '10px' }}>COFINS:</span>
      <span>{`${formatPorcentagem(record.cofins)}`}</span>
    </div>
    <div style={{ marginTop: '5px' }}>
      <span style={{ fontWeight: 'bold', marginRight: '10px' }}>ICMS AI:</span>
      <span>{`${formatPorcentagem(record.icms_ai)}`}</span>
    </div>
    <div style={{ marginTop: '5px' }}>
      <span style={{ fontWeight: 'bold', marginRight: '10px' }}>ICMS INT:</span>
      <span>{`${formatPorcentagem(record.icms_int)}`}</span>
    </div>
    <div style={{ marginTop: '5px' }}>
      <span style={{ fontWeight: 'bold', marginRight: '10px' }}>DF:</span>
      <span>{`${formatPorcentagem(record.df)}`}</span>
    </div>
    <div style={{ marginTop: '5px' }}>
      <span style={{ fontWeight: 'bold', marginRight: '10px' }}>RBC:</span>
      <span>{`${formatPorcentagem(record.rbc)}`}</span>
    </div>
  </div>
);

const List2 = (props) => (
  <ProtegerPagina permissao="publico">
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      expand={<PostPanel />}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Impostos Produtos"
    />
  </ProtegerPagina>
);

export default List2;
